import { Box, Lock, Star, StarFill, TrashBin } from "@gravity-ui/icons";
import { Button, Card, Flex, Icon, Text, User } from "@gravity-ui/uikit";
import { useAction, useAtom } from "@reatom/npm-react";
import { BrowserAccountDto } from "definitions/poizon-api";
import { useState } from "react";
import { useScreenSize } from "src/hooks";
import {
  CUSTOM_SIZES,
  MINIMAL_INNER_WIDTH,
} from "src/pages/ProfilePage/ProfilePage.constants";
import { RoutesPaths } from "src/routes/RoutesPaths";
import { ShowConfirmDialog } from "src/widgets/Alert/Alert";

import {
  selectedPoizonClientAtom,
  selectPoizonClientAction,
} from "../../store/atoms/selectedPoizonClient";
import { deletePoizonClient } from "../../store/fetchers/deletePoizonClient";
import { AuthClientModal } from "../AuthClientModal/AuthClientModal";
import css from "./UserClient.module.scss";
import { UserClientIconButton } from "./UserClientIconButton/ButtonIcon";

interface UserClientProps {
  userClient: BrowserAccountDto;
}
enum ClientStatuses {
  OK = 200,
  NEED_AUTH = 7999,
  BANNED = 403,
}
export const UserClientWidget = ({ userClient }: UserClientProps) => {
  const clientId = userClient.id;
  const clientStatus = userClient.status;
  const { userName, mobile } = userClient.data ?? {};
  const [selectedClient] = useAtom(selectedPoizonClientAtom);
  const selectClient = useAction(selectPoizonClientAction);
  const isCurrentClient = userClient.id == selectedClient;
  const screenSize = useScreenSize();
  const [authModalIsOpen, setAuthModal] = useState(false);
  const deleteClient = useAction(deletePoizonClient);

  const handleDelete = async () => {
    const result = await ShowConfirmDialog(
      "Вы действительно хотите удалить клиент?",
      "Подтвердите действие",
    );
    if (result) deleteClient(clientId);
  };

  const isMaximized = screenSize.width <= MINIMAL_INNER_WIDTH;
  const customSizes = CUSTOM_SIZES(isMaximized);
  const isAuthed = userName && mobile;
  return (
    <Card className={css.userClientCard} theme="normal" view="filled" size="m">
      {!isAuthed ? (
        <Button
          size="l"
          onClick={() => setAuthModal(true)}
          view="flat-info"
          selected
        >
          <Icon data={Lock} />
          Авторизоваться
        </Button>
      ) : (
        <div>
          <div className={css.clientIdHint}>
            <Text variant="caption-1" color="hint">
              #{clientId}
            </Text>
          </div>
          <User
            avatar={{
              text: userName,
              theme: "brand",
              color: "#f0f0f0",
              backgroundColor: "#000000",
            }}
            name={userName ?? "No name"}
            description={mobile ?? "No data"}
          />
        </div>
      )}

      <Flex
        direction="row"
        wrap="wrap"
        gap="0.5"
        width={customSizes.elementWidth}
        justifyContent="end"
      >
        <AuthClientModal
          isOpen={authModalIsOpen}
          onClose={() => setAuthModal(false)}
          clientId={clientId.toString()}
        />
        {isAuthed && (
          <UserClientIconButton
            tooltip="Посылки"
            iconSize={customSizes.icon}
            iconData={Box}
            buttonSize={customSizes.button}
            disableButton={clientStatus !== ClientStatuses.OK}
            to={RoutesPaths.LK.CLIENT_ORDERS(clientId.toString())}
          />
        )}
        {isAuthed && (
          <UserClientIconButton
            tooltip="Авторизоваться"
            iconSize={customSizes.icon}
            iconData={Lock}
            buttonSize={customSizes.button}
            disableButton={clientStatus !== ClientStatuses.NEED_AUTH}
            onClick={() => setAuthModal(true)}
          />
        )}
        <UserClientIconButton
          tooltip="Сделать основным"
          iconSize={customSizes.icon}
          buttonView={isCurrentClient ? "flat-warning" : "flat"}
          buttonSize={customSizes.button}
          iconData={isCurrentClient ? StarFill : Star}
          disableButton={false}
          onClick={() => selectClient(clientId)}
        />
        <UserClientIconButton
          tooltip="Удалить"
          iconSize={customSizes.icon}
          iconData={TrashBin}
          buttonSize={customSizes.button}
          disableButton={false}
          onClick={handleDelete}
        />
      </Flex>
    </Card>
  );
};
